import { render } from "./buySponsorAccounts.vue?vue&type=template&id=50628075"
import script from "./buySponsorAccounts.vue?vue&type=script&lang=js"
export * from "./buySponsorAccounts.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__